import type { EmailActivity } from '@common/types/activities';
import { Box, Link, Typography } from '@mui/material';
import ShowLessButton from '../ShowLessButton';

interface Props {
    emailBody: EmailActivity['body'];
    isBodyExpanded: boolean;
    setIsBodyExpanded: (val: boolean) => void;
}

export default function IntakeReminderExhaustToLawyerBody({
    emailBody,
    isBodyExpanded,
    setIsBodyExpanded,
}: Props) {
    return (
        <Box
            sx={{
                marginTop: '16px',
                wordWrap: 'break-word',
                overflowWrap: 'anywhere',
            }}
        >
            <Typography variant="h4" sx={{ marginBottom: '16px' }}>
                Intake reminders limit exhaust
            </Typography>
            <Typography variant="body2" color="text.primary">
                This is to inform you that the maximum number of reminders has been sent for the
                below-mentioned prospect:
            </Typography>
            <Box
                sx={{
                    marginTop: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.primary',
                        fontWeight: '600',
                    }}
                >
                    Prospect:{' '}
                    <Link sx={{ textDecoration: 'none' }} href={emailBody?.ProspectLink}>
                        {emailBody?.ProspectName}
                    </Link>
                </Typography>
                <Typography variant="body2" color="text.primary">
                    <span style={{ fontWeight: '600' }}>Reminder Type:</span>{' '}
                    {emailBody?.ReminderType}
                </Typography>
                <Typography variant="body2" color="text.primary">
                    <span style={{ fontWeight: '600' }}>Client Name:</span> {emailBody?.ClientName}
                </Typography>
                <Typography variant="body2" color="text.primary">
                    <span style={{ fontWeight: '600' }}>Client Email:</span>{' '}
                    <a href={`mailto:${emailBody?.ClientEmail}`}>{emailBody?.ClientEmail}</a>
                </Typography>
            </Box>
            <ShowLessButton
                isBodyExpanded={isBodyExpanded}
                bodyExpandedHandler={setIsBodyExpanded}
            />
        </Box>
    );
}
